import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b9e017a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h100 w100 flex-box align-center justify-center" }
const _hoisted_2 = {
  key: 0,
  class: "p-grid p-dir-col"
}
const _hoisted_3 = { class: "p-col" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = { for: "username" }
const _hoisted_6 = { class: "p-col" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = { for: "password" }
const _hoisted_9 = { class: "p-col" }
const _hoisted_10 = {
  action: "/oauth2/authorization/google",
  method: "post"
}

import {ComponentPublicInstance, inject, onMounted, reactive, ref} from "vue"
import axios from "axios"
import focus from "@/views/focus"
import {LoginSuccessActionKey} from "@/login-success-action"
import "@/styles/common.scss"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

class State {
    username = ""
    password = ""
    error = false
    allowPasswordAuthentication = false
}

const state = reactive(new State())

const usernameRef = ref<ComponentPublicInstance<HTMLElement>>()
const passwordRef = ref<ComponentPublicInstance<HTMLElement>>()

const loginSuccessAction = inject(LoginSuccessActionKey)
const checkAllowPasswordAuthentication = async () => {
    try {
        const res = await axios.get<boolean>("/apac")

        if (res && res.data) {
            state.allowPasswordAuthentication = res.data
        }
    } catch (e) {
        state.error = true
        if (usernameRef.value) {
            focus(usernameRef.value.$el)
        }
    }
}

const login = async () => {
    // 未入力の場合は終了
    const {username, password} = state

    if (!username) {
        if (usernameRef.value) {
            focus(usernameRef.value.$el)
        }
        return
    }

    if (!password) {
        if (passwordRef.value) {
            focus(passwordRef.value.$el.children[0])
        }
        return
    }

    const params = new URLSearchParams()
    params.append("username", username)
    params.append("password", password)

    try {
        await axios.post("/auth", params, {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
        if (loginSuccessAction != null) loginSuccessAction("/")
    } catch (e) {
        state.error = true
        if (usernameRef.value) {
            focus(usernameRef.value.$el)
        }
    }
}

onMounted(() => {
    checkAllowPasswordAuthentication()
    if (usernameRef.value) {
        focus(usernameRef.value.$el)
    }
})


return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { style: {"width":"35em","margin-bottom":"2em","text-align":"center","padding":"15px"} }, {
      title: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('appName')), 1)
      ]),
      content: _withCtx(() => [
        (_unref(state).allowPasswordAuthentication)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('username')), 1),
                  _createVNode(_component_InputText, {
                    id: "username",
                    type: "text",
                    modelValue: _unref(state).username,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).username) = $event)),
                    ref: (_value, _refs) => {
                      _refs['usernameRef'] = _value
                      usernameRef.value = _value
                    }
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('password')), 1),
                  _createVNode(_component_Password, {
                    id: "password",
                    modelValue: _unref(state).password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).password) = $event)),
                    feedback: false,
                    ref: (_value, _refs) => {
                      _refs['passwordRef'] = _value
                      passwordRef.value = _value
                    }
                  }, null, 8, ["modelValue"])
                ])
              ]),
              (_unref(state).error)
                ? (_openBlock(), _createBlock(_component_Message, {
                    key: 0,
                    severity: "error",
                    onClose: _cache[2] || (_cache[2] = ($event: any) => (_unref(state).error = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("err.000020")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Button, {
                  class: "login-button",
                  onClick: login,
                  label: _ctx.$t('login')
                }, null, 8, ["label"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("form", _hoisted_10, [
            _createVNode(_component_Button, {
              type: "submit",
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("googleLogin")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})